import dayjs from 'dayjs';
import moment from 'moment';

export const formatFirestoreTimestampMMDDYYYY = (firestoreTimestamp) => {
    try {
        // Check if firestoreTimestamp is valid and has toDate method
        if (firestoreTimestamp && typeof firestoreTimestamp.toDate === 'function') {
            const date = firestoreTimestamp.toDate(); // Convert to JavaScript Date object
            // Format date to MM/DD/YYYY
            const formattedDate = (date.getMonth() + 1).toString().padStart(2, '0') + '/' +
                                  date.getDate().toString().padStart(2, '0') + '/' +
                                  date.getFullYear();
            return formattedDate;
        } else {
            return "N/A"; // Return "N/A" if input is not a valid Firestore timestamp
        }
    } catch (error) {
        console.error("Error formatting Firestore timestamp:", error);
        return "N/A"; // Return "N/A" in case of any error during conversion
    }
}

export const formatFirestoreTimestampToTime = (timeStamp) => {
    if(!timeStamp) return "N/A"
    return new Date(timeStamp.seconds * 1000).toLocaleTimeString()
}

export const formatFirestoreTimestampDDMMHHMMSS = (firestoreTimestamp) => {
    try {
        if (firestoreTimestamp && typeof firestoreTimestamp.toDate === 'function') {
            const date = firestoreTimestamp.toDate(); // Convert to JavaScript Date object
            let hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            
            hours = hours % 12;
            hours = hours ? hours : 12; // The hour '0' should be '12'
            
            const formattedDate = date.getDate().toString().padStart(2, '0') + '/' +
                                  (date.getMonth() + 1).toString().padStart(2, '0') + ' ' +
                                  hours.toString().padStart(2, '0') + ':' +
                                  minutes.toString().padStart(2, '0') + ':' +
                                  seconds.toString().padStart(2, '0') + ' ' +
                                  ampm;
            return formattedDate;
        } else {
            return "N/A"; // Return "N/A" if input is not a valid Firestore timestamp
        }
    } catch (error) {
        console.error("Error formatting Firestore timestamp:", error);
        return "N/A"; // Return "N/A" in case of any error during conversion
    }
}

// Helper function to convert decimal time to dayjs object
export const decimalToDayjs = (decimal) => {
    const hours = Math.floor(decimal);
    const minutes = (decimal % 1) * 60;
    return dayjs().hour(hours).minute(minutes);
};

// Helper function to convert dayjs object to decimal time
export const dayjsToDecimal = (dayjsObj) => {
    const hours = dayjsObj.hour();
    const minutes = dayjsObj.minute();
    return hours + minutes / 60;
};

export const formatFirestoreTimestamp = (timestamp) => {
    if (!timestamp) return '';
    return moment(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000).format('h:mm A');
};
